
(() => {
  if (window.GZMobileSwipeFix) return;
  window.GZMobileSwipeFix = true;

  const SELECTOR = '.splide';
  const MIN_DISTANCE = 35;

  const initialized = new WeakSet();

  function initializeSlider(slider) {
    if (initialized.has(slider)) return;
    if (!slider.splide) return;

    const splide = slider.splide;

    // Non modificare gli slider senza drag
    if (!splide.options.drag) return;

    initialized.add(slider);

    // Disattiva il drag nativo di Splide
    splide.options = { drag: false };

    let gesture = null;

    slider.addEventListener('touchstart', (event) => {
      if (window.innerWidth > 767) return;
      if (event.touches.length !== 1) return;

      const touch = event.touches[0];

      gesture = {
        x: touch.clientX,
        y: touch.clientY,
        index: splide.index
      };
    }, { passive: true, capture: true });

    slider.addEventListener('touchend', (event) => {
      if (!gesture) return;

      const start = gesture;
      gesture = null;

      if (window.innerWidth > 767) return;

      const touch = event.changedTouches[0];
      if (!touch) return;

      const dx = touch.clientX - start.x;
      const dy = touch.clientY - start.y;

      if (
        Math.abs(dx) < MIN_DISTANCE ||
        Math.abs(dx) <= Math.abs(dy)
      ) return;

      const slideWidth =
        splide.Components.Layout.slideSize(0);

      if (!slideWidth) return;

      const steps = Math.max(
        1,
        Math.round(Math.abs(dx) / slideWidth)
      );

      const isRTL = splide.options.direction === 'rtl';
      const direction = isRTL ? 1 : -1;

      const target = Math.max(
        0,
        Math.min(
          splide.Components.Controller.getEnd(),
          start.index + Math.sign(dx) * direction * steps
        )
      );

      splide.go(target);
    }, { passive: true, capture: true });

    slider.addEventListener('touchcancel', () => {
      gesture = null;
    }, { passive: true, capture: true });
  }

  function scan() {
    if (window.innerWidth > 767) return;

    document.querySelectorAll(SELECTOR).forEach(
      initializeSlider
    );
  }

  const observer = new MutationObserver(scan);

  function start() {
    scan();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener('scroll', scan, {
      passive: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();
